import React, {useState} from 'react'

function MultiSelectBox({ selected = false, onSelect = () => null, children = <></> }) {

    const [isHovered, setIsHovered] = useState(false);

    return (
        <div 
            className={`box is-clickable ${selected ? 'has-border-1-link' : 'is-greyscale is-transparent-70'} ${isHovered ? 'has-background-light' : 'has-background-white'}`}
            onClick={e => onSelect()}
            onMouseEnter={e => setIsHovered(true)}
            onMouseLeave={e => setIsHovered(false)}
        >
            <div>
                {children}
            </div>
            
        </div>
    )
}

export default MultiSelectBox;